
export const data1 = [

    {
      famille: "box",
      articleNom: "family box",
      prix:35.900,
      compo:'Crêpe panée poulet mexicain + Crêpe panée jambon fumé champignon + Poulet pané + Frite + Boisson gazeuse',
    },
    {
      famille: "box",
      articleNom: "couple box",
      prix: 21.900,
      compo:'Crêpe panée jambon fumé champignon + Poulet pané + Frite',
    },
    {
      famille: "menu kids",
      articleNom: "menu kids",
      prix: 12.900,
      compo:'Poulet pané + Frite + Boisson gazeuse',
    },
    {
      famille: "menu kids",
      articleNom: "menu kids",
      prix: 13.900,
      compo:'Poulet crunchy + Frite + Boisson gazeuse',
    },
    {
      famille: "menu kids",
      articleNom: "menu kids",
      prix: 15.900,
      compo:'Mini pizza thon + Frite + Boisson gazeuse',
    },
    {
      famille: "menu kids",
      articleNom: "menu kids",
      prix: 15.900,
      compo:'Mini pizza pepperoni + Frite + Boisson gazeuse',
    },
    {
      famille: "menu kids",
      articleNom: "menu kids",
      prix: 15.900,
      compo:'Mini pizza jambon champignon + Frite + Boisson gazeuse',
    },
    {
      famille: "menu kids",
      articleNom: "menu kids",
      prix: 15.900,
      compo:'Mini pizza poulet champignon + Frite + Boisson gazeuse',
    },
    /*-----------------------------------pasta-------------------------------------------------*/
    {
      famille: "pastas",
      articleNom: "Pasta Puttanesca",
      prix: 14.900,
      compo:'Sauce tomate + Thon + Piment de Cayenne + Olives noire + Câpres',
    },
    {
      famille: "pastas",
      articleNom: "Pasta Poulet à la Crème",
      prix: 18.900,
      compo:'Sauce blanche + Jambon fumé + émincé de poulet + Courgette + Champignons de paris Parmesan',
    },
    {
      famille: "pastas",
      articleNom: "Pasta Parisienne",
      prix: 18.900,
      compo:'Sauce rosée + Blanc de poulet Champignons + Parmesan',
    },
    {
      famille: "pastas",
      articleNom: "Pasta Chili",
      prix: 21.900,
      compo:'Sauce blanche + Poulet pané + chorizo de boeuf + Champignons + Peperoncino'
    },
    {
      famille: "pastas",
      articleNom: "Pasta Pesto",
      prix: 22.900,
      compo:'Sauce blanche + Pesto + Blanc de poulet + Pignon + Parmesan'
    },
    /*-----------------------------------plats du jour-------------------------------------------------*/
    {
      famille: "PLATS DU JOUR",
      articleNom: "Poulet grillé",
      prix: 17.900,
      compo:'',
    },
    {
      famille: "PLATS DU JOUR",
      articleNom: "Poulet pané",
      prix: 17.900,
      compo:'',
    },
    {
      famille: "PLATS DU JOUR",
      articleNom: "Chich taouk",
      prix: 18.900,
      compo:'',
    },
    {
      famille: "PLATS DU JOUR",
      articleNom: "Poulet crunchy",
      prix: 18.900,
      compo:'',
    },
    {
      famille: "PLATS DU JOUR",
      articleNom: "Poulet mexicain",
      prix: 18.900,
      compo:'',
    },
    {
      famille: "PLATS DU JOUR",
      articleNom: "Kabeb",
      prix: 18.900,
      compo:'',
    },
    /*-----------------------------------CHAKLOUB-------------------------------------------------*/
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 11.900,
      compo:'Poulet grillé + Fromage slice',
    },
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 11.900,
      compo:'Poulet pané + Fromage slice',
    },
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 11.900,
      compo:'Chich taouk + Fromage slice',
    },
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 11.900,
      compo:'Poulet mexicain + Fromage slice',
    },
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 12.900,
      compo:'Kabeb + Fromage slice',
    },
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 12.900,
      compo:'Poulet grillé + Chorizo + œuf + Fromage slice',
    },
    {
      famille: "CHAKLOUB",
      articleNom: "CHAKLOUB",
      prix: 13.900,
      compo:'thon + œuf + Fromage slice',
    },
    /*-----------------------------------Sandwich-------------------------------------------------*/
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 8.900,
      compo:'Poulet grillé',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 8.900,
      compo:'Poulet pané',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 8.900,
      compo:'Chich taouk',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 9.900,
      compo:'Thon + œuf',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 9.900,
      compo:'Kabeb + œuf',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 9.900,
      compo:'Poulet mexicain + Fromage slice',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 11.900,
      compo:'Poulet pané + jambon Fumé + Fromage slice',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 11.900,
      compo:'Merguez + œuf + Fromage slice',
    },
    {
      famille: "SANDWICHS",
      articleNom: "SANDWICH",
      prix: 12.900,
      compo:'Poulet grillé + Chorizo + œuf + Fromage slice',
    },
     /*-----------------------------------CRÊPE PANÉE-------------------------------------------------*/
     {
      famille: "CRÊPE PANÉE",
      articleNom: "CRÊPE PANÉE",
      prix: 11.900,
      compo:'Jambon fumé + champignon + Fromage',
    },
    {
      famille: "CRÊPE PANÉE",
      articleNom: "CRÊPE PANÉE",
      prix: 13.900,
      compo:'Poulet mexicain + Fromage',
    },
    {
      famille: "CRÊPE PANÉE",
      articleNom: "CRÊPE PANÉE",
      prix: 14.900,
      compo:'kabeb + Fromage',
    },
    {
      famille: "CRÊPE PANÉE",
      articleNom: "CRÊPE PANÉE",
      prix: 14.900,
      compo:'Poulet + chorizo + champignon',
    },
     /*-----------------------------------------LES SALADES-------------------------------------------*/
     {
      famille: "LES SALADES",
      articleNom: "Salade fraicheur",
      prix: 12.900,
      compo:'Laitue - Tomate - Roquette - Fruits séchés - Graines de chia - Graine de tournesol - Noix de cajou - Oeuf',
    },
    {
      famille: "LES SALADES",
      articleNom: "Salade César",
      prix: 16.900,
      compo:'Laitue + Tomate cerise + Sauce césar + Poulet grillé ou pané + Parmesan',
    },
     /*-----------------------------------------HEALTHY FOOD-------------------------------------------*/
     {
      famille: "HEALTHY FOOD",
      articleNom: "SUPER BOL HEALTHY",
      prix: 15.900,
      compo:'Riz ou Borghol + Poulet + Oeuf + Salade (Fruits séchés Graines de chia + Graine de tournesol + Noix de cajou)',
    },
    {
      famille: "HEALTHY FOOD",
      articleNom: "SUPER BOL kabab",
      prix: 17.900,
      compo:'Riz ou Borghol + Kabab + Oeuf + Broccolini + Champignons grillés + Frite au four',
    },
  ]
  export const data2 = [
 /*-----------------------------------------PETIT DEJEUNER FORMULE SIMPLE-------------------------------------------*/
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "SALÉ",
      prix:8,
      compo:'Café au choix Batbout (2 pièces) Jus (citron ou orange)',
    },
    
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "SALÉ",
      prix:8,
      compo:' Café au choix-Croissant sale Jus (citron ou orange)',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "SALÉ",
      prix:10,
      compo:' Café au choix Omelette végétarienne Jus (citron ou orange)',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:7.5,
      compo:' Café au choix Cake gourmand - Eau 0,5L',
    },
     {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:8,
      compo:'Café au choix yaourt fruits et fruits sec Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:10,
      compo:' Café au choix-Croissant Nutella Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:10,
      compo:'Café au choix Gâteau du jour Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:10,
      compo:'Café au choix-Mini gaufre au Nutella-Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:10,
      compo:'Café au choix-Mini gaufre Caramel beurre salé - Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:10,
      compo:' Café au choix-Mini Crepe Nutella - Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "GOURMET",
      prix:10,
      compo:'Café au choix Mini Crêpe caramel beurre salé - Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "EXPRESS",
      prix:8,
      compo:' Café au choix Une Banane Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "TRADITIONEL",
      prix:9,
      compo:' Café ture Verre d"eau- Assortiment de pâtisserie traditionnelle',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "HEALTHY",
      prix:10,
      compo:' Café au choix 1/2 Fruit Chocolat noir (72% cacao) Noix de cajou Biscotte Ricotta Miel. Eau 0,5L',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "BERBÈRE",
      prix:8,
      compo:' Cafe turc Bambalouni-Jarre d"eau',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "BERBÈRE",
      prix:8,
      compo:' Café au choix. Batbout sucré (chamia, beure, confiture)- Jarre d"eau',
    },
    {
      famille: "PETIT DEJEUNER FORMULE SIMPLE",
      articleNom: "BERBÈRE",
      prix:9,
      compo:'Café au choix-BOL, DROS (Chamia, Fruits sec)-Jarre d"eau',
    },
    /*-----------------------------------------PETIT DEJEUNER FORMULE COMPOSÉE-------------------------------------------*/
    {
      famille: "PETIT DEJEUNER FORMULE COMPOSÉE",
      articleNom: "MATINALE",
      prix:10,
      compo:'Café au choix-Croissant au choix ou cake. Biscotte à tartiner Beurre et confiture Jus frais (citron ou orange)',
    },
    {
      famille: "PETIT DEJEUNER FORMULE COMPOSÉE",
      articleNom: "LE PARISIEN",
      prix:16,
      compo:'Café au choix-Croissant sucré au choix. Omelette (jambon, champignon de paris) Macaron Jus frais (citron ou orange)',
    },
    {
      famille: "PETIT DEJEUNER FORMULE COMPOSÉE",
      articleNom: "CONTINENTAL",
      prix:17,
      compo:'Café au choix. Croissant sucré au choix Batbout salé Omelette végétarienne Yaourt aux fruits et fruits secs Jus frais (citron ou orange)',
    },
    {
      famille: "PETIT DEJEUNER FORMULE COMPOSÉE",
      articleNom: "HEALTHY",
      prix:19,
      compo:'Café au choix ou the infusion Croissant céréale (x) Biscotte Ricotta Miel Omelette Blanc d"oeuf l-Grain de chia Fruits-Noix de cajou (x)-Chocolat noir (72% cacao). Jus Détox',
    },
    {
      famille: "PETIT DEJEUNER FORMULE COMPOSÉE",
      articleNom: "SALE",
      prix:32,
      compo:' Café au choix Cake gourmand Croissant sale Assortiment de charcuterie et fromage Harissa Ojja merguez Panier pain Yaourt aux fruits et fruits secs Jus frais (citron ou orange) - Eau 0,5L',
    },
    /*-----------------------------------------CAFÉ-------------------------------------------*/
    {
      famille: "CAFÉ",
      articleNom: "Express",
      prix:3.5,
      compo:'',
    },
    {
      famille: "CAFÉ",
      articleNom: "Capucin",
      prix: 4.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Grand crème",
      prix: 4.5,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Nescafe",
      prix: 6.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Nesquik",
      prix: 6.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Cappuccino",
      prix: 8.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Caramel",
      prix: 8.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Noisette",
      prix: 8.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Café glacé",
      prix: 9.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Cafe frappuccino nutella",
      prix: 11.0,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Express LAVAZZA",
      prix:5,
      compo:'',
    },
    {
      famille: "CAFÉ",
      articleNom: "Capucin LAVAZZA",
      prix: 5.5,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Grand crème LAVAZZA",
      prix: 6,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Express NESPRESSO",
      prix:6,
      compo:'',
    },
    {
      famille: "CAFÉ",
      articleNom: "Capucin NESPRESSO",
      prix: 6.5,
      compo: '',
    },
    {
      famille: "CAFÉ",
      articleNom: "Grand crème NESPRESSO",
      prix: 7,
      compo: '',
    },
    {
      famille: "CHICHA",
      articleNom: "CHICHA MENTHE",
      prix: 10.0,
      compo: '',
    },
    {
      famille: "CHICHA",
      articleNom: "CHICHA RAISIN MENTHE",
      prix: 10.0,
      compo: '',
    },
    {
      famille: "CHICHA",
      articleNom: "CHICHA LOVE",
      prix: 15.0,
      compo: '',
    },
    /*-----------------------------------------thé-------------------------------------------*/
    
    {
      famille: "THÉ",
      articleNom: "THÉ VERT À LA MENTHE",
      prix: 4.0,
      compo: '',
    },
    {
      famille: "THÉ",
      articleNom: "THÉ INFUSION MENTHE",
      prix: 6.0,
      compo: '',
    },
    {
      famille: "THÉ",
      articleNom: "THÉ INFUSION CITRON",
      prix: 6.0,
      compo: '',
    },
    {
      famille: "THÉ",
      articleNom: "THÉ INFUSION FRUITS",
      prix: 6.0,
      compo: '',
    },
    {
      famille: "THÉ",
      articleNom: "VERVEINE",
      prix: 6.0,
      compo: '',
    },
    {
      famille: "THÉ",
      articleNom: "THE AUX AMANDES",
      prix: 10.0,
      compo: '',
    },
    {
      famille: "THÉ",
      articleNom: "THE AUX AMANDES",
      prix: 10.0,
      compo: '',
    },
    /*-----------------------------------------CAFÉ GOURMET-------------------------------------------*/
  
    {
      famille: "CAFÉ GOURMET",
      articleNom: "SALÉ",
      prix: 7.5,
      compo: ' Café au choix Batbout (2 pièces) Café au choix-Croissant salé',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "SALÉ",
      prix: 7.5,
      compo: 'Café au choix-Croissant salé',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 6,
      compo: 'Café au choix-Assielette cookies',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 7.5,
      compo: 'Café au choix - Cake gourmand',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 8,
      compo: 'Café au choix - Brawnies chocolat',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 9,
      compo: 'Café au choix - Café au choix-Croissant Nutella',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 9,
      compo: 'Café au choix - Gateau du jour',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 10,
      compo: 'Café au choix-Mini Gaufre au nutella',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 10,
      compo: 'Café au choix-Mini gaufre Caramel beurre salé',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 10,
      compo: ' Café au choix-Mini Crêpe Nutella',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GOURMET",
      prix: 10,
      compo: 'Café au choix-Mini Crêpe caramel beurre salé',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "GRAND MÈRE",
      prix: 8,
      compo: 'Café-Gâteau grand-mère',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "TRADITIONEL",
      prix: 9,
      compo: 'Café turc Verre d"eau Assortiment de pâtisserie traditionnelle',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "BERBÈRE",
      prix: 8,
      compo: 'Café turc Bambalouni-Jarre d"eau',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "BERBÈRE",
      prix: 8,
      compo: 'Café au choix - Batbout sucré (chamia, beure, confiture) - Jarre d"eau',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "BERBÈRE",
      prix: 9,
      compo: 'Café au choix BOL DROS (Chamia, Fruits sec)-Jarre d"eau',
    },
    {
      famille: "CAFÉ GOURMET",
      articleNom: "HEALTHY",
      prix: 10,
      compo: 'Café au choix-1/2 Fruit Chocolat noir-Noix de cajou Biscotte Ricotta-Miel Eau 0,5L',
    },
        /*-----------------------------------------Boissons froides-------------------------------------------*/
        {
          famille: "Boissons froides",
          articleNom: " EAU MINÉRALE 0,5L",
          prix: 2,
          compo: '',
        },
        {
          famille: "Boissons froides",
          articleNom: " EAU MINÉRALE 0,9L",
          prix: 4,
          compo: '',
        },
        {
          famille: "Boissons froides",
          articleNom: "EAU GAZEIFIÉE",
          prix: 4,
          compo: '',
        },
        {
          famille: "Boissons froides",
          articleNom: "BOISSON GAZEUSE",
          prix: 6,
          compo: '',
        },
        {
          famille: "Boissons froides",
          articleNom: "PÉTILLANTE",
          prix: 7,
          compo: '',
        },
        {
          famille: "Boissons froides",
          articleNom: "SCHWEPPS",
          prix: 7,
          compo: '',
        },
        {
          famille: "Boissons froides",
          articleNom: "BOISSON ÉNERGÉTIQUE",
          prix: 9.5,
          compo: '',
        },
        /*-----------------------------------------JUS FRAIS-------------------------------------------*/
        {
          famille: "JUS FRAIS",
          articleNom: "JUS D'ORANGE",
          prix: 8,
          compo: '',
        },
        {
          famille: "JUS FRAIS",
          articleNom: "CITRONNADE",
          prix: 8,
          compo: '',
        },
        {
          famille: "JUS FRAIS",
          articleNom: "JUS DE PÊCHE",
          prix: 10,
          compo: '',
        },
        {
          famille: "JUS FRAIS",
          articleNom: "JUS DE FRUITS ROUGES",
          prix: 10,
          compo: '',
        },
        {
          famille: "JUS FRAIS",
          articleNom: "CITRONNADE AUX AMANDES",
          prix: 12,
          compo: '',
        },
          /*-----------------------------------------COCKTAILS-------------------------------------------*/
          {
            famille: "COCKTAILS",
            articleNom: "MOJITO CLASSIQUE",
            prix: 9,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "GRANITE CITRON",
            prix: 9,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "JUS DÉTOX FRAÎCHEUR",
            prix: 9,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "JUS DÉTOX EXOTIQUE",
            prix: 10,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "MOJITO BLUE",
            prix: 10,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "MOJITO FRUIT ROUGE",
            prix: 10,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "LAIT DE POULE",
            prix: 10,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "BANANE FRUITS ROUGES",
            prix: 11,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "BANANE ORANGE KIWI",
            prix: 11,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "CITRONADE À LA GLACE",
            prix: 11,
            compo: '',
          },
          {
            famille: "COCKTAILS",
            articleNom: "MOJITO ÉNERGÉTIQUE",
            prix: 15,
            compo: '',
          },
           /*-----------------------------------------SMOOTHIES-------------------------------------------*/
           {
            famille: "SMOOTHIES",
            articleNom: "BANANE KIWI MENTHE",
            prix: 12,
            compo: '',
          },
          {
            famille: "SMOOTHIES",
            articleNom: "BANANE FRUITS ROUGES",
            prix: 12,
            compo: '',
          },
           /*-----------------------------------------MILKSHAKE-------------------------------------------*/
           {
            famille: "MILKSHAKE",
            articleNom: "CARAMEL BEURRE SALÉ",
            prix: 11,
            compo: '',
          },
          {
            famille: "MILKSHAKE",
            articleNom: "OREO",
            prix: 12,
            compo: '',
          },
          {
            famille: "MILKSHAKE",
            articleNom: "NUTELLA",
            prix: 12,
            compo: '',
          },
          /*-----------------------------------------LES GAUFRES-------------------------------------------*/
          {
            famille: "LES GAUFRES",
            articleNom: "GAUFRE CARAMEL BEURRE SALÉ",
            prix: 10,
            compo: '',
          },
          {
            famille: "LES GAUFRES",
            articleNom: "GAUFRE NUTELLA",
            prix: 11,
            compo: '',
          },
          {
            famille: "LES GAUFRES",
            articleNom: "GAUFRE NUTELLA NOISETTES",
            prix: 15,
            compo: '',
          },
          {
            famille: "LES GAUFRES",
            articleNom: "GAUFRE NUTELLA BANANE OU FRUITS ROUGES",
            prix: 15,
            compo: '',
          },
          /*-----------------------------------------LES PANCAKES-------------------------------------------*/
          {
            famille: "LES PANCAKES",
            articleNom: "PANCAKE CARAMEL BEURRE SALÉ",
            prix: 10,
            compo: '',
          },
          {
            famille: "LES PANCAKES",
            articleNom: "PANCAKE NUTELLA",
            prix: 11,
            compo: '',
          },
          {
            famille: "LES PANCAKES",
            articleNom: " PANCAKE NUTELLA BANANE OU FRUITS DE ROUGES",
            prix: 15,
            compo: '',
          },
          /*-----------------------------------------LES CRÊPES SUCRÉES-------------------------------------------*/
          {
            famille: "LES CRÊPES SUCRÉES",
            articleNom: "CRÊPE CARAMEL BEURRE SALÉ",
            prix: 10,
            compo: '',
          },
          {
            famille: "LES CRÊPES SUCRÉES",
            articleNom: "CRÊPE NUTELLA",
            prix: 11,
            compo: '',
          },
          {
            famille: "LES CRÊPES SUCRÉES",
            articleNom: "CRÊPE NUTELLA BANANE OU FRUITS ROUGES",
            prix: 15,
            compo: '',
          },
          {
            famille: "LES CRÊPES SUCRÉES",
            articleNom: "CRÊPE NUTELLA NOISETTE",
            prix: 15,
            compo: '',
          },
           /*-----------------------------------------LES CRÊPES SALÉES-------------------------------------------*/
           {
            famille: "LES CRÊPES SALÉES",
            articleNom: "CRÊPE PARISIENNE",
            prix: 11,
            compo: 'Jambon fumé Champignons Moutarde · Fromage',
          },
          {
            famille: "LES CRÊPES SALÉES",
            articleNom: "CRÊPE TUNISIENNE",
            prix: 12,
            compo: 'Thon-Fromage',
          },
          {
            famille: "LES CRÊPES SALÉES",
            articleNom: "CRÊPE ARABIYATA",
            prix: 13,
            compo: 'Poulet-Légumes sautés à l"ail-Moutarde Fromage Parka fumée',
          },
          {
            famille: "LES CRÊPES SALÉES",
            articleNom: "CRÊPE MEXICAINE",
            prix: 14,
            compo: 'Poulet marinée-Légumes sautés à la mexicaine-Fromage',
          },
          {
            famille: "LES CRÊPES SALÉES",
            articleNom: "CRÊPE TEXAS",
            prix: 15,
            compo: 'Poulet marinée Chorizo de boeuf Champignons Fromage-Parika fumée - Poivron',
          },
            /*-----------------------------------------LES OMELETTES-------------------------------------------*/
            {
              famille: "LES OMELETTES",
              articleNom: "VÉGÉTARIENNE",
              prix: 10,
              compo: 'Œufs Courgette Oignon-Champignons Fromage - Poivron',
            },
            {
              famille: "LES OMELETTES",
              articleNom: "PARISIENNE",
              prix: 12,
              compo: 'Œufs Jambon fumé Champignons Fromage',
            },
            {
              famille: "LES OMELETTES",
              articleNom: "TUNISIENNE",
              prix: 13,
              compo: 'Œufs Thon Fromage Poivron',
            },
            {
              famille: "LES OMELETTES",
              articleNom: "GRECQUE",
              prix: 14,
              compo: 'Œufs Poulet-Fromage Poivron',
            },
            {
              famille: "LES OMELETTES",
              articleNom: "CHORIZO",
              prix: 16,
              compo: 'Œufs Poulet Chorizo de boeuf- Fromage Champignons Parika fumée-Poivron',
            },
              /*-----------------------------------------LES PANINIS-------------------------------------------*/
              {
                famille: "LES PANINIS",
                articleNom: "THON FROMAGE",
                prix: 9,
                compo: 'THON FROMAGE',
              },
              {
                famille: "LES PANINIS",
                articleNom: "JAMBON FROMAGE",
                prix: 9,
                compo: 'Jambon fumé Champignons Fromage',
              },
              {
                famille: "LES PANINIS",
                articleNom: "CHORIZO",
                prix: 9,
                compo: 'Chorizo de boeuf Fromage',
              },
              {
                famille: "LES PANINIS",
                articleNom: "POULET FROMAGE",
                prix: 10,
                compo: 'Poulet-Fromage',
              },
                /*-----------------------------------------LES PLATS DU JOUR-------------------------------------------*/
                {
                  famille: "LES PLATS DU JOUR",
                  articleNom: "SUPER BOL",
                  prix: 15,
                  compo: 'Borghol-Poulet-Oeuf Salade',
                },
                {
                  famille: "LES PLATS DU JOUR",
                  articleNom: "FORMULE STANDARD",
                  prix: 18,
                  compo: 'Velouté. Poulet pané ou grillé-Purée pomme de terre Riz-Salade. The ou jus',
                },
                {
                  famille: "LES PLATS DU JOUR",
                  articleNom: "SPORTIF",
                  prix: 25,
                  compo: 'Poulet grillé (300g/630 calories) Riz (200g/302 calories) Légumes grillés ou salade verte (100g/345 calories) Banane (133,5 calories)',
                },
                {
                  famille: "LES PLATS DU JOUR",
                  articleNom: "POULET À LA CRÈME",
                  prix: 28,
                  compo: 'Suprême de poulet-Sauce blanche Champignons',
                },
                 /*-----------------------------------------PASTAS-------------------------------------------*/
                 {
                  famille: "PASTAS",
                  articleNom: "PUTANESCA",
                  prix: 15,
                  compo: 'Sauce tomate.Thon- Piment de cayenne Olive noir Capres',
                },
                {
                  famille: "PASTAS",
                  articleNom: "POULET À LA CRÈME DE CHAMPIGNONS",
                  prix: 22,
                  compo: 'Sauce blanche Jambon fumé Emincée de poulet-Courgette Champignon de paris Parmesan',
                },
                {
                  famille: "PASTAS",
                  articleNom: "PARISIENNE",
                  prix: 22,
                  compo: 'Sauce blanche Emincée de boeuf Champignon de paris Chorizo Parmesan',
                },
                {
                  famille: "PASTAS",
                  articleNom: "BOLOGNAISE",
                  prix: 23,
                  compo: 'Sauce tomate Viande hachée Piment de cayenne. Parmesan',
                },
                {
                  famille: "PASTAS",
                  articleNom: "POMOSALI",
                  prix: 23,
                  compo: 'Sauce blanche Poulet-Poivron-Champignon Piment de cayenne- Parmesan',
                },
                {
                  famille: "PASTAS",
                  articleNom: "CHILLI",
                  prix: 25,
                  compo: 'Sauce blanche Poulet pané Chorizo de boeuf Champignon-Peperoncino',
                },
                {
                  famille: "PASTAS",
                  articleNom: "QUATTRO FROMAGGI",
                  prix: 25,
                  compo: 'Sauce blanche-Mozzarella Gruyère Gorgonzola Parmesan',
                },
                {
                  famille: "PASTAS",
                  articleNom: "POULET PESTO ET PIGNON",
                  prix: 26,
                  compo: 'Sauce blanche Sauce pesto Blanc de poulet-Pignon-Parmesan',
                },
                {
                  famille: "PASTAS",
                  articleNom: "ANGELINA",
                  prix: 26,
                  compo: 'Sauce blanche Emincée de boeuf Champignon de paris Chorizo Parmesan',
                },
                  /*-----------------------------------------PATISSERIE ET DESSERT-------------------------------------------*/
                  {
                    famille: "PATISSERIE ET DESSERT",
                    articleNom: "GATEAUX DU JOUR",
                    prix: 6,
                    compo: '',
                  },
                  {
                    famille: "PATISSERIE ET DESSERT",
                    articleNom: "TARTE DU JOUR",
                    prix: 6,
                    compo: '',
                  },
                  {
                    famille: "PATISSERIE ET DESSERT",
                    articleNom: "TIRAMISU",
                    prix: 9,
                    compo: '',
                  },
                  {
                    famille: "PATISSERIE ET DESSERT",
                    articleNom: "CHEESECAKE",
                    prix: 9,
                    compo: '',
                  },
                  {
                    famille: "PATISSERIE ET DESSERT",
                    articleNom: "FONDANT AU CHOCOLAT",
                    prix: 9,
                    compo: '',
                  },
                   /*-----------------------------------------LES PIZZAS-------------------------------------------*/
                   {
                    famille: "LES PIZZAS",
                    articleNom: "MARGHERITA",
                    prix: 15,
                    compo: 'Sauce tomate Mozzarella Basilic Tomate cerise',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "VÉGÉTARIENNE",
                    prix: 18,
                    compo: 'Sauce tomate. Mozzarella Champignons Courgette Poivron Oignons',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "PEPPERONI",
                    prix: 18,
                    compo: 'Sauce tomate. Mozzarella Pepperoni',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "LA REINE",
                    prix: 20,
                    compo: 'Sauce blanche Mozzarella Jambon fume Champignons Tomate cerise',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "POULET CHAMPIGNON",
                    prix: 24,
                    compo: 'Sauce blanche-Blanc de poulet-Mozzarella Champignons Tomate cerise',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "TUNA",
                    prix: 24,
                    compo: 'Sauce tomate Mozzarella-Thon - Oignon Roivron Olives noires',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "TEXAS",
                    prix: 27,
                    compo: 'Sauce blanche Poulet marinée Chorizo de boeuf Champignons Fromage. Parika fumée-Poivron',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "MEXICAINE",
                    prix: 28,
                    compo: 'Sauce tomate Mozzarella Viande hachée Poivron Tomate cerise-Roquette',
                  },
                  {
                    famille: "LES PIZZAS",
                    articleNom: "QUATTRO FROMAGGI",
                    prix: 28,
                    compo: ' Sauce blanche Mozzarella Gruyère Roquefort Parmesan',
                  },
                   /*----------------------------------------- LES SALADES-------------------------------------------*/
                   {
                    famille: "LES SALADES",
                    articleNom: "CLASSIQUE",
                    prix: 14,
                    compo: 'Laitue Tomate Oignions Mals Poivron Oeuf Pané-Thon Vinaigrette',
                  },
                  {
                    famille: "LES SALADES",
                    articleNom: "FRAICHEUR",
                    prix: 16,
                    compo: 'Laitue Tomate Roquette Fruits séchés graines de chia-Graine de tournesol noix de cajou ',
                  },
                  {
                    famille: "LES SALADES",
                    articleNom: "CÉSAR",
                    prix: 17,
                    compo: 'Laitue Tornate cerise Sauce césar Poulet grillé ou pané Parmesan',
                  },
                  {
                    famille: "LES SALADES",
                    articleNom: "PARISIENNE",
                    prix: 19,
                    compo: 'Laitue Tomate Roquette Fromage camembert pane-Vinaigrette',
                  },
                  {
                    famille: "LES SALADES",
                    articleNom: "BRESAOLA",
                    prix: 22,
                    compo: 'Bresaola Poulet panée Croton-Laitue Tomate Fromage Vinaigrette',
                  },
                    /*----------------------------------------- LES SANDWICHS-------------------------------------------*/
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "UNO",
                      prix: 10,
                      compo: 'Poulet mariné grillé-Laitue Oignons Poivron Frite',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "TURQUE",
                      prix: 10,
                      compo: ' Roulet grille-Légumes.grilles.(oignons, poivron)-Persil',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "CRISPY",
                      prix: 10.5,
                      compo: 'Poulet marinė pané Laitue Oignons. Poivron',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "DIABLO POULET",
                      prix: 13,
                      compo: 'Poulet marinée Fromage Légumes sautés à la mexicaine',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "BAMBO",
                      prix: 13,
                      compo: ' Poulet marine pané Sauce du chef Harissa Jambon fumé: Laitue. Oignons. Tomate Fromage cheddar',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "HABIBI",
                      prix: 13,
                      compo: 'Merguez oeuf-Sauce piquante Harissa Laitue Oignons Tomate · Fromage cheddar',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "MARIO",
                      prix: 14,
                      compo: 'Poulet marine Chorizo de boeuf Champignons Sauce chimichurri Fromage',
                    },
                    {
                      famille: "LES SANDWICHS",
                      articleNom: "POULET GRATINÉ",
                      prix: 15,
                      compo: 'Poulet marine-Sauce piquante-Fromage.raclette',
                    },
  ]
  
 
 

 
  
  
  